"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WEBSOCKET_URL = exports.DATA_EXPORTS_URL = exports.ADMIN_OPERATOR_URL = exports.ADMIN_OPERATOR_EVENT_URL = exports.ADMIN_OPERATOR_EVENT_TYPE_URL = exports.ADMIN_OPERATOR_CONTACT_URL = exports.ADMIN_OPERATOR_ALIAS_URL = exports.ADMIN_OPERATOR_ADDRESS_URL = exports.ADMIN_FILE_URL = exports.ADMIN_ETL_RUNS_URL = exports.ADMIN_ETL_METRICS_URL = void 0;
exports.ADMIN_ETL_METRICS_URL = '/admin/etl/metrics';
exports.ADMIN_ETL_RUNS_URL = '/admin/etl/runs';
exports.ADMIN_FILE_URL = '/admin/files';
exports.ADMIN_OPERATOR_ADDRESS_URL = '/admin/operators/addresses';
exports.ADMIN_OPERATOR_ALIAS_URL = '/admin/operators/aliases';
exports.ADMIN_OPERATOR_CONTACT_URL = '/admin/operators/contacts';
exports.ADMIN_OPERATOR_EVENT_TYPE_URL = '/admin/operators/event-types';
exports.ADMIN_OPERATOR_EVENT_URL = '/admin/operators/events';
exports.ADMIN_OPERATOR_URL = '/admin/operators';
exports.DATA_EXPORTS_URL = '/exports';
exports.WEBSOCKET_URL = '/api/socket.io/';
//# sourceMappingURL=urls.js.map